// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import client from '../../sanity/client';
// import './SubPageTransmission.scss';
// import { useLanguage } from '../../components/LanguageContext';

// const SubPageTransmission = () => {
//   const { slug } = useParams();
//   const [data, setData] = useState(null);
//   const { language } = useLanguage();
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);

//   // Fonction pour obtenir le texte dans la bonne langue
//   const getText = (textObj) =>
//     textObj && textObj[language] ? textObj[language] : "Texte non disponible";

//   // Gestion du resize pour basculer en vue mobile/desktop
//   const handleResize = () => {
//     setIsMobileView(window.innerWidth <= 992);
//   };

//   useEffect(() => {
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       const query = `*[_type == "subPageTransmission" && slug.current == $slug][0]{
//         title,
//         mainText,
//         secondaryText,
//         "mainImageUrl": mainImage.asset->url,
//         gallery[]{ "imageUrl": asset->url + "?auto=format" }
//       }`;
//       const result = await client.fetch(query, { slug });
//       setData(result);
//     };

//     fetchData();
//   }, [slug]);

//   if (!data) return <div>Loading...</div>;

//   // Détermine si l'ordre doit être inversé pour certains slugs
//   const reverseOrder = slug === 'preparer-ses-argiles' || slug === 'modeler-un-bol';

//   // Rendu mobile
//   const renderMobile = () => {
//     if (reverseOrder) {
//       return (
//         <>
//           <div className="text-content-h1">
//             <h1>{data.title}</h1>
//           </div>
//           <div className="image-content">
//             <img
//               src={data.mainImageUrl}
//               alt={data.title || "Main Image"}
//               className="main-image"
//             />
//             {data.gallery &&
//               data.gallery.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Gallery Image ${index}`}
//                   className="gallery-image"
//                 />
//               ))
//             }
//           </div>
//           <div className="text-content">
//             <div className="text-content-1">
//               {data.mainText && data.mainText[language] &&
//                 data.mainText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//             <div className="text-content-1">
//               {data.secondaryText && data.secondaryText[language] &&
//                 data.secondaryText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//           </div>
//         </>
//       );
//     } else {
//       return (
//         <>
//           <div className="text-content-h1">
//             <h1>{data.title}</h1>
//           </div>
//           <div className="image-content">
//             <img
//               src={data.mainImageUrl}
//               alt={data.title || "Main Image"}
//               className="main-image"
//             />
//             {data.gallery &&
//               data.gallery.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Gallery Image ${index}`}
//                   className="gallery-image"
//                 />
//               ))
//             }
//           </div>
//           <div className="text-content">
//             <div className="text-content-1">
//               {data.mainText && data.mainText[language] &&
//                 data.mainText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//             <div className="text-content-1">
//               {data.secondaryText && data.secondaryText[language] &&
//                 data.secondaryText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//           </div>
//         </>
//       );
//     }
//   };

//   // Rendu desktop
//   const renderDesktop = () => {
//     if (reverseOrder) {
//       return (
//         <>
//           <div className="text-content sticky">
//             <div className="text-content-h1">
//               <h1>{data.title}</h1>
//             </div>
//             <div className="text-content-1">
//               {data.mainText && data.mainText[language] &&
//                 data.mainText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//             <div className="text-content-1">
//               {data.secondaryText && data.secondaryText[language] &&
//                 data.secondaryText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//           </div>
//           <div className="image-content">
//             <img
//               src={data.mainImageUrl}
//               alt={data.title || "Main Image"}
//               className="main-image"
//             />
//             {data.gallery &&
//               data.gallery.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Gallery Image ${index}`}
//                   className="gallery-image"
//                 />
//               ))
//             }
//           </div>
//         </>
//       );
//     } else {
//       return (
//         <>
//           <div className="image-content">
//             <img
//               src={data.mainImageUrl}
//               alt={data.title || "Main Image"}
//               className="main-image"
//             />
//             {data.gallery &&
//               data.gallery.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Gallery Image ${index}`}
//                   className="gallery-image"
//                 />
//               ))
//             }
//           </div>
//           <div className="text-content sticky">
//             <div className="text-content-h1">
//               <h1>{data.title}</h1>
//             </div>
//             <div className="text-content-1">
//               {data.mainText && data.mainText[language] &&
//                 data.mainText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//             <div className="text-content-1">
//               {data.secondaryText && data.secondaryText[language] &&
//                 data.secondaryText[language].split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))
//               }
//             </div>
//           </div>
//         </>
//       );
//     }
//   };

//   return (
//     <div className="subpage-transmission">
//       <div className="content-container">
//         {isMobileView ? renderMobile() : renderDesktop()}
//       </div>
//     </div>
//   );
// };

// // export default SubPageTransmission;

import React, { useEffect, useState } from 'react';
import client from '../../sanity/client';
import './SubPageTransmission.scss';
import { useLanguage } from '../../components/LanguageContext';

const SubPagesTransmission = () => {
  const [pages, setPages] = useState([]);
  const { language } = useLanguage();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);
  
  const getSectionId = (titleObj) => {
  // Toujours utiliser le français pour les ID
  const title = titleObj?.fr || titleObj?.en || titleObj || 'titre';
  return title.toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .trim();
};
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobileView) return; // Pas de gestion sticky sur mobile

    const handleScroll = () => {
      const contentContainers = document.querySelectorAll('.content-container');
      
      contentContainers.forEach((container) => {
        const textContent = container.querySelector('.text-content');
        const textScrollableContent = container.querySelector('.text-scrollable-content');
        const textInner = container.querySelector('.text-inner');
        const imageContent = container.querySelector('.image-content');
        
        if (!textContent || !imageContent || !textInner || !textScrollableContent) return;

        const containerRect = container.getBoundingClientRect();
        
        // Calculer les hauteurs (maintenant on se base sur le contenu scrollable, pas le titre)
        const textHeight = textInner.scrollHeight;
        const containerHeight = textScrollableContent.clientHeight;
        const maxScrollDistance = textHeight - containerHeight;
        
        // Si le texte tient dans le conteneur, pas besoin de scroll
        if (maxScrollDistance <= 0) {
          textInner.style.transform = 'translateY(0px)';
          return;
        }
        
        // Calculer le progrès du scroll basé sur la position de la section
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const viewportHeight = window.innerHeight;
        
        // La section est-elle visible ?
        if (containerBottom < 0 || containerTop > viewportHeight) {
          return; // Section hors de vue
        }
        
        // Calculer le pourcentage de progression dans la section
        const sectionHeight = container.offsetHeight;
        
        // MODIFICATION: Démarrer le scroll plus tard (quand on a scrollé 30% de la section)
        // et finir plus tôt (avant la fin de la section)
        const startScrollThreshold = 0.3; // Commence à 30% du scroll de la section
        const endScrollThreshold = 0.8;   // Finit à 80% du scroll de la section
        
        const rawProgress = (viewportHeight - containerTop) / (sectionHeight + viewportHeight);
        
        // Ajuster le progrès pour qu'il commence plus tard et finisse plus tôt
        const adjustedProgress = Math.max(0, Math.min(1, 
          (rawProgress - startScrollThreshold) / (endScrollThreshold - startScrollThreshold)
        ));
        
        // Appliquer le scroll proportionnel au texte (seulement le contenu, pas le titre)
        const scrollOffset = adjustedProgress * maxScrollDistance;
        textInner.style.transform = `translateY(-${scrollOffset}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Appel initial
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobileView, pages]);

  useEffect(() => {
    const fetchPages = async () => {
      const query = `*[_type == "subPageTransmission"] | order(order asc) {
        title,
        order,
        isReversed,
        mainText,
        secondaryText,
        "mainImageUrl": mainImage.asset->url,
        gallery[]{ "imageUrl": asset->url + "?auto=format" }
      }`;
      const results = await client.fetch(query);
      setPages(results);
    };

    fetchPages();
  }, []);

  const getText = (textObj) => {
    if (!textObj) return null;
    if (typeof textObj === 'string') return textObj;
    return textObj[language] || textObj.fr || textObj.en || null;
  };


  const renderBlock = (item, index) => {
    const reversed = item.isReversed;
    
    const imageBlock = (
      <div className="image-content image-content-top">
        {item.mainImageUrl && (
          <img
            src={item.mainImageUrl}
            alt={item.title?.[language] || item.title?.fr || item.title?.en || "Image"}
            className="main-image"
          />
        )}
        {item.gallery?.map((image, idx) => (
          image.imageUrl && (
            <img
              key={idx}
              src={image.imageUrl}
              alt={`Gallery Image ${idx}`}
              className="gallery-image"
            />
          )
        ))}
      </div>
    );

    const textBlock = (
      <div className={isMobileView ? "text-content" : "text-content"} data-section-index={index}>
        {/* Titre fixe qui reste toujours visible */}
        <div className="text-content-h2 padding-exception2">
          <h2>{item.title?.[language] || item.title?.fr || item.title?.en || ''}</h2>
        </div>
        
        {/* Contenu scrollable avec parallax */}
        <div className="text-scrollable-content">
          <div className="text-inner">
            {getText(item.mainText) && (
              <div className="text-content-1">
                {getText(item.mainText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
            )}
            {getText(item.secondaryText) && (
              <div className="text-content-1">
                {getText(item.secondaryText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );

    return (
      <div className="content-container" key={index}>
        {isMobileView
          ? <>
              {textBlock}
              {imageBlock}
            </>
          : reversed
          ? <>
              {textBlock}
              {imageBlock}
            </>
          : <>
              {imageBlock}
              {textBlock}
            </>
        }
      </div>
    );
  };

  if (!pages.length) return <div>Loading...</div>;

  return (
    <div  className="subpage-transmission">
      {pages.map((page, index) => {
        const sectionId = getSectionId(page.title || 'sans-titre');
        return (
          <div id={sectionId} key={index} className="subpage-transmission">
            {renderBlock(page, index)}
          </div>
        );
      })}
    </div>
  );
};

export default SubPagesTransmission;

// import React, { useEffect, useState } from 'react';
// import client from '../../sanity/client';
// import { useLanguage } from '../../components/LanguageContext';
// import './TransmissionPage.scss';

// const TransmissionPage = () => {
//   const { language } = useLanguage();
//   const [mainTitle, setMainTitle] = useState(null);
//   const [subPages, setSubPages] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const transmissionQuery = `*[_type == "transmission"][0]{ title }`;
//       const subPagesQuery = `*[_type == "subPageTransmission"]{
//         _id,
//         title,
//         "slug": slug.current,
//         "imageUrl": image.asset->url,
//         content
//       }`;

//       const [pageData, subPageData] = await Promise.all([
//         client.fetch(transmissionQuery),
//         client.fetch(subPagesQuery),
//       ]);

//       setMainTitle(pageData?.title || {});
//       setSubPages(subPageData || []);
//     };

//     fetchData();
//   }, []);
//   if (!mainTitle || !mainTitle[language]) return <div>Loading…</div>;

//   return (
//     <div className="transmission-page titre-page">
//       <h1 className="transmission-title">{mainTitle[language]}</h1>
  
//       {subPages.map((page) => (
//         <section key={page._id} id={page.slug} className="transmission-subpage">
//           <h2>{page.title?.[language] ?? ''}</h2>
//           {page.imageUrl && (
//             <img src={page.imageUrl} alt={page.title?.[language] ?? ''} />
//           )}
//           <p>{page.content?.[language] ?? ''}</p>
//         </section>
//       ))}
//     </div>
//   );
// };

// export default TransmissionPage;